import { render, staticRenderFns } from "./rup-sagor.vue?vue&type=template&id=5098f7c5&scoped=true&"
import script from "./rup-sagor.vue?vue&type=script&lang=js&"
export * from "./rup-sagor.vue?vue&type=script&lang=js&"
import style0 from "./rup-sagor.vue?vue&type=style&index=0&id=5098f7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098f7c5",
  null
  
)

export default component.exports